import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @ViewChild('loading', { static: true }) loading;

  loading$ = this.loadingService.loading$;

  overlayRef;

  show: boolean;

  constructor(private overlay: Overlay, private viewContainerRef: ViewContainerRef, private loadingService: LoadingService) { }

  ngOnInit(): void {
    const strategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();
    const config = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy: strategy,
    });
    this.overlayRef = this.overlay.create(config);
    this.loading$.subscribe(state => {
      this.show = state;
      if (state && this.overlayRef) {
        if (!this.overlayRef.hasAttached()) {
          this.overlayRef.attach(new TemplatePortal(this.loading, this.viewContainerRef));
        }
      } else {
        this.overlayRef.detach();
      }
    })
  }

}
